import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type CategoryBaseFragment = { id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean };

export const CategoryBaseFragmentDoc = gql`
    fragment CategoryBaseFragment on CategoryType {
  id
  name
  url
  pk
  slug
  description
  metaDescription
  keywords
  metaTitle
  level
  isWholesale
}
    `;